import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { DEFAULT_SETTINGS } from "constants/readabilityThresholds";
import { modalTypes } from "constants/types";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { resetDefaults } from "slices/settings/actions/thresholds";

const ResetDefaultsModal = () => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.RESET_DEFAULTS_THRESHOLDS));
  };
  const handleSubmit = () => {
    dispatch(resetDefaults());
  };
  const settings = DEFAULT_SETTINGS;

  return (
    <Modal
      data-testid="resetDefaultThresholdsModal"
      className="thresholds_defaults_modal fade-in"
      show
      onDismiss={handleCancel}
      backdrop
      centered
    >
      <Modal.Header>
        <b>Restore Thresholds</b>
      </Modal.Header>
      <Modal.Body>
        <p>
          We will revert all changes to thresholds to all users within the VT
          Docs workspace. The default threshold settings are:
        </p>
        <table
          className="table table-striped table-bordered"
          data-testid="resetDefaultsThresholdsModalTable"
        >
          <thead>
            <tr>
              <th scope="col">&nbsp;</th>
              <th scope="col">
                <strong>Bad</strong>
              </th>
              <th scope="col">
                <strong>Good</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Long Sentences:</td>
              <td>{settings.thresholdLongSentenceUpper}%</td>
              <td>{settings.thresholdLongSentenceLower}%</td>
            </tr>
            <tr>
              <td>Passive Voice:</td>
              <td>{settings.thresholdPassiveVoiceUpper}%</td>
              <td>{settings.thresholdPassiveVoiceLower}%</td>
            </tr>
            <tr>
              <td>Average Sentence Length:</td>
              <td>{settings.thresholdAvgSentenceUpper} words</td>
              <td>{settings.thresholdAvgSentenceLower} words</td>
            </tr>
            <tr>
              <td>Readability (Flesch):</td>
              <td>{settings.thresholdReadabilityLower}</td>
              <td>{settings.thresholdReadabilityUpper}</td>
            </tr>
            <tr>
              <td>Readability (LIX):</td>
              <td>{settings.thresholdLixReadabilityUpper}</td>
              <td>{settings.thresholdLixReadabilityLower}</td>
            </tr>
            <tr>
              <td>Grade Level:</td>
              <td>{settings.thresholdGradeLevelUpper}</td>
              <td>{settings.thresholdGradeLevelLower}</td>
            </tr>
            <tr>
              <td>Long Sentence Cutoff:</td>
              <td colSpan="2">25 words</td>
            </tr>
            <tr>
              <td>Very Long Sentence Cutoff:</td>
              <td colSpan="2">30 words</td>
            </tr>
            <tr>
              <td>Lix score for all folders:</td>
              <td colSpan="2">disabled</td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
      <Modal.Footer>
        <NewButton onClick={handleCancel} variant={NewButtonVariant.l2}>
          Close
        </NewButton>

        <NewButton onClick={handleSubmit} variant={NewButtonVariant.l1}>
          Confirm
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetDefaultsModal;
